export default __webpack_public_path__ + "static/media/TLI_Claim_Form.24248d8b.pdf";